module.exports = __webpack_public_path__ + "img/mob_close_menu_icon.65e6c017.svg";